// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1K_zX","right":"styles_right__3Wrcs"};